var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm.nRequiredErrors ? _c('div', {
    staticClass: "px-4 pb-3 error--text"
  }, [_vm._v(" You have not provided valid input for " + _vm._s(_vm.pl(_vm.nRequiredErrors, 'required section')) + ". "), _vm.count(function (x) {
    return ['SUCCESS', 'SUCCESS_MIXED'].includes(x);
  }) ? _c('span', [_vm._v(" The project will not include "), _c('b', [_vm._v("any")]), _vm._v(" of your inputs.")]) : _vm._e()]) : _vm._e(), _c('div', {
    staticClass: "px-4 my-n3"
  }, _vm._l(_vm.sections, function (section) {
    return section.n ? _c('div', {
      staticClass: "d-flex align-center my-3"
    }, [_c('v-icon', {
      staticClass: "flex-grow-0 mr-2",
      attrs: {
        "color": section.color
      }
    }, [_vm._v(_vm._s(section.icon))]), _c('label', {
      staticClass: "v-label theme--light"
    }, [_vm._v(_vm._s(section.msg(section.n)))])], 1) : _vm._e();
  }), 0)]);

}
var staticRenderFns = []

export { render, staticRenderFns }